export enum Roles {
	Owner = "Owner",
	Landlord = "Landlord",
	Tenant = "Tenant",
	Administrator = "Administrator",
	SystemAdministrator = "SystemAdministrator",
	SystemSupervisor = "SystemSupervisor",
	ClientAdministrator = "ClientAdministrator"
}